export default "__VITE_ASSET__w96ue4E$__"